import { createBrowserRouter } from 'react-router';
import { AppRoutesEnum } from '@features/routing/routesEnum';
import MainLayout from '@layouts/main-layout/MainLayout';
import { AdminLayout } from '@layouts/admin-layout/AdminLayout';
import Home from '@pages/home/Home';
import { About } from '@pages/about/About';
import { History } from '@pages/history/History';
import { Faq } from '@pages/faq/Faq';
import Contact from '@pages/contact/Contact';
import Gallery from '@pages/gallery/Gallery';
import Order from '@pages/order/Order';
import OrderCat from '@pages/order-cat/OrderCat';
import { Partners } from '@pages/partners/Partners';
import PartnersRegistration from '@pages/partners-registration/PartnersRegistration';
import PartnersOrder from '@pages/partners-order/PartnersOrder';
import NotFoundPage from '@pages/not-found/NotFoundPage';
import SalesNetwork from '@pages/sales-network/SalesNetwork';
import ThankYou from '@pages/thank-you/ThankYou';
import { ArticleList } from '@pages/admin/article-list/ArticleList';
import { NewArticle } from '@pages/admin/article/NewArticle';
import { ExistArticle } from '@pages/admin/article/ExistArticle';
import { AuthorizedPage } from '@features/authentication/AuthorizedPage';
import AppLogic from '@layouts/app-logic/AppLogic';



export const router = createBrowserRouter([
	{
		path: AppRoutesEnum.basePath,
		element: <AppLogic />,
		children: [
			{
				path: AppRoutesEnum.basePath,
				element: <MainLayout />,
				children: [
					{
						index: true,
						element: <Home />
					},
					{
						path: AppRoutesEnum.about,
						element: <About />
					},
					{
						path: AppRoutesEnum.history,
						element: <History />
					},
					{
						path: AppRoutesEnum.order,
						element: <Order />
					},
					{
						path: AppRoutesEnum.orderSelect,
						element: <Order />
					},
					{
						path: AppRoutesEnum.catOrder,
						element: <OrderCat />
					},
					{
						path: AppRoutesEnum.gallery,
						element: <Gallery />
					},
					{
						path: AppRoutesEnum.partners,
						element: <Partners />
					},
					{
						path: AppRoutesEnum.partnersRegistration,
						element: <PartnersRegistration />
					},
					{
						path: AppRoutesEnum.partnersOrder,
						element: <PartnersOrder />
					},
					{
						path: AppRoutesEnum.faq,
						element: <Faq />
					},
					{
						path: AppRoutesEnum.contact,
						element: <Contact />
					},
					{
						path: AppRoutesEnum.salesNetwork,
						element: <SalesNetwork />
					},
					{
						path: AppRoutesEnum.thankYouOrder,
						element: <ThankYou />
					},
					{
						path: AppRoutesEnum.thankYouRegistration,
						element: <ThankYou registration={true} />
					},
				]
			},
			{
				element: <AdminLayout />,
				children: [
					{
						element: <AuthorizedPage />,
						children: [
							{
								path: AppRoutesEnum.admin,
								element: <ArticleList />,
							},
							{
								path: AppRoutesEnum.article,
								children: [
									{
										index: true,
										element: <NewArticle />,
									},
									{
										path: ':id',
										element: <ExistArticle />
									}
								],
							}
						]
					},
				]
			},
			{
				element: <MainLayout />,
				children: [
					{
						path: "*",
						element: <NotFoundPage />
					}
				]
			}
		]
	}
]);